import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from '@environments/environment';
import { RouterLink } from '@angular/router';
import { Resources } from '@app/resources';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    TranslatePipe,
    RouterLink
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

  // set the currenr year
  year: number = new Date().getFullYear();

  protected readonly environment = environment;
  protected readonly Resources = Resources;
}
